module.exports = __webpack_public_path__ + "img/li-circle-error.4d1ee9b3.svg";